export default __webpack_public_path__ + "static/media/scrum.6bd01fcc.svg";